import { Injectable, inject } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { PaginatedPendingOrderResponse } from '../models/pending-order.model';

import { ApiService } from './api.service';
import { RegisterService } from './register.service';

export interface PendingOrdersQueryParams {
  page: number;
  size: number;
  sortField?: string;
  sortDirection?: 'asc' | 'desc';
}

@Injectable({
  providedIn: 'root',
})
export class PendingOrdersService {
  private readonly baseUrl = `${environment.externalGateServiceUrl}/companies`;
  private apiService = inject(ApiService);
  private registerService = inject(RegisterService);


  getRequestsOrders(
    document: string,
    params: PendingOrdersQueryParams
  ): Observable<PaginatedPendingOrderResponse> {
    const cleanDocument = this.registerService.cleanDocument(document);
    const sortField = params.sortField ?? 'createdAt';
    const sortDirection = params.sortDirection ?? 'desc';

    const httpParams = new HttpParams()
      .set('document', cleanDocument)
      .set('status', 'ACTIVE')
      .set('page', String(params.page))
      .set('size', String(params.size))
      .set('sort', `${sortField},${sortDirection}`);

    const url = `${this.baseUrl}/requests-orders?${httpParams.toString()}`;
    return this.apiService.getExternal<PaginatedPendingOrderResponse>(url);
  }
}
